import React, { useState, useEffect } from "react";
import { PaperContainer } from "../../common/PaperContainer";
import { CircularProgress, Modal, Typography } from "@material-ui/core";
import { CygniPieChart } from "../../common/CygniPieChart";
import {
  queryPrep,
  getEdoAbrev,
  getEdoClaveIntelite,
  numberWithCommas,
} from "../../common/Cygni";
import { CygniModalList } from "../../common/CygniModal";
import {
  getCategorias,
  getNotasParaExportar,
} from "../../common/CygniRequests";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { CygniLoading } from "../../common/CygniLoading";
import { useRechartToPng } from "recharts-to-png";
// import { CygniBarChart } from "../../common/CygniBarChart";

export const MediosCategorias = React.memo(({ query, fecha1, fecha2 }) => {
  const [data, setData] = useState(null);
  const [moduleData, setModuleData] = useState(null);
  const [open, setOpen] = useState(false);
  const [filtro, setFiltro] = useState("null");
  const [exportStatus, setExportStatus] = useState("");
  const [png, ref] = useRechartToPng();
  const qry = queryPrep(query);
  const f1 = fecha1.replace(/-/g, "_");
  const f2 = fecha2.replace(/-/g, "_");
  // const [changeChart, setChangeChart] = useState(false);

  useEffect(() => {
    setData(null);
    setExportStatus("");

    // Categorias
    getCategorias(qry, f1, f2)
      .then(function (response) {
        setData(response.data);
        setModuleData(response.moduleData);
      })
      .catch(function (error) {
        setData([]);
        setModuleData(null);
        console.error(error);
      });
  }, [query, fecha1, fecha2]);

  const chartClick = (chartData, index) => {
    if (chartData && chartData.payload !== null) {
      handleOpen(chartData.payload.payload);
    }
  };

  const handleOpen = async (selectedData) => {
    setOpen(true);
    setFiltro(getEdoClaveIntelite(getEdoAbrev(selectedData.name)));
  };

  const handleClose = () => {
    setOpen(false);
  };

  let categLabel = function (entry) {
    return entry.name
      .replace("Ciudad de México", "CDMX")
      .replace("Estado de México", "Edomex");
  };

  const exportarNotas = () => {
    if (data && moduleData) {
      setExportStatus("LOADING");
      getNotasParaExportar(
        qry,
        fecha1,
        fecha2,
        moduleData.totNotas,
        null,
        null,
        null,
        null,
        moduleData.exportParams
      )
        .then(function (response) {
          const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
          const fileExtension = ".xlsx";
          const exportData = response.data.busqueda1;
          const ws = XLSX.utils.json_to_sheet(exportData);
          const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
          const excelBuffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
          });
          const data = new Blob([excelBuffer], { type: fileType });
          FileSaver.saveAs(data, "query_categorias" + fileExtension);
          setExportStatus("DONE");
        })
        .catch(function (error) {
          console.error(error);
          setExportStatus("ERROR");
        });
    }
  };

  const downloadChart = React.useCallback(async () => {
    FileSaver.saveAs(png, "notas_por_edo.png");
  }, [png]);

  return (
    <React.Fragment>
      <PaperContainer
        title={"Top estados"}
        subtitle={
          data &&
          data.length > 0 &&
          moduleData &&
          moduleData.totNotas &&
          numberWithCommas(moduleData.totNotas) + " notas"
        }
        exportData={data}
        exportName="medios_categ"
        exportarNotas={exportarNotas}
        downloadChart={downloadChart}
        // toggleChart={() => setChangeChart(!changeChart)}
      >
        {exportStatus === "LOADING" && (
          <React.Fragment>
            <Typography color="primary" align="center" variant="caption">
              Exportando notas...
            </Typography>
            <CircularProgress
              size={15}
              color="secondary"
              style={{ margin: "auto" }}
            />
          </React.Fragment>
        )}
        {exportStatus === "DONE" && (
          <Typography color="primary" align="center" variant="caption">
            Exportación de notas finalizada.
          </Typography>
        )}
        {exportStatus === "ERROR" && (
          <Typography color="secondary" align="center" variant="caption">
            Exportación de notas falló.
          </Typography>
        )}
        {!data && <CygniLoading />}
        {data && data.length === 0 && (
          <Typography
            component="h5"
            variant="h5"
            align="center"
            style={{ marginTop: "10px" }}
          >
            No hay datos disponibles.
          </Typography>
        )}
        {/* {data && data.length > 0 && !changeChart && ( */}
        {data && data.length > 0 && (
          <CygniPieChart
            dataKey="value"
            data={data}
            labelLine={true}
            label={categLabel}
            chartClick={chartClick}
            exportRef={ref}
            legend={true}
          />
        )}
        {/* {data && data.length > 0 && changeChart && (
          <CygniBarChart
            data={data}
            keysAndColors={[{ value: "#12b831" }]}
            chartClick={chartClick}
            exportRef={ref}
          />
        )} */}
      </PaperContainer>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div>
          <CygniModalList
            qry={qry}
            f1={f1}
            f2={f2}
            title="Detalle de notas"
            loadMore={true}
            estados={filtro}
          />
        </div>
      </Modal>
    </React.Fragment>
  );
});
